import { useForm } from "react-hook-form";
import { changePasswordApi } from "../../APIs/API";
import { handleLogout } from "../../utils/utils";
import { useNavigate } from "react-router-dom";

const ChangepswdComp = () => {
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm();

  const validatePasswordMatch = (value) => {
    return value === watch("new_password") || "Passwords do not match";
  };

  const onSubmit = async (data) => {
    try {
      const res = await changePasswordApi(data);
      handleLogout();
      navigate("/");
    } catch (error) {
      console.log(error.message);
    }
  };

  return (
    <>
      <form className="change-pswd-main" onSubmit={handleSubmit(onSubmit)}>
        <div className="edit-profile-main d-flex flex-column ">
          <div className="edit-profile-inner d-flex flex-column gap-3">
            <h5>Current Password</h5>
            <input
              {...register("current_password", {
                required: "Current password is required",
                // minLength: {
                //   value: 10,
                //   message: "Must be at least 10 characters long",
                // },
                // pattern: {
                //   value: /^(?=.*[A-Z])(?=.*[!@#$%^&*])(?=.*[0-9]).{8,}$/,
                //   message:
                //     "Must contain at least one uppercase letter, one special character, and one digit",
                // },
              })}
              inputMode="text"
              type="password"
              placeholder="Type..."
              className="modal-input "
            />
            {errors.current_password && (
              <span className="error">{errors.current_password.message}</span>
            )}
          </div>
          <div className="partition-line"></div>
          <div className="d-flex gap-85 pswd-inner">
            <div className="edit-profile-inner d-flex flex-column gap-3">
              <h5>New Password</h5>
              <input
                {...register("new_password", {
                  required: "New password is required",
                  // minLength: {
                  //   value: 10,
                  //   message: "Must be at least 10 characters long",
                  // },
                  // pattern: {
                  //   value: /^(?=.*[A-Z])(?=.*[!@#$%^&*])(?=.*[0-9]).{8,}$/,
                  //   message:
                  //     "Must contain at least one uppercase letter, one special character, and one digit",
                  // },
                })}
                inputMode="text"
                type="password"
                placeholder="Type..."
                className="modal-input "
              />
              {errors.new_password && (
                <span className="error">{errors.new_password.message}</span>
              )}
            </div>
            <div className="edit-profile-inner d-flex flex-column gap-3">
              <h5>Confirm Password</h5>
              <input
                {...register("confirm_password", {
                  required: "Confirm password is required",
                  validate: validatePasswordMatch,
                  // minLength: {
                  //   value: 10,
                  //   message: "Must be at least 10 characters long",
                  // },
                  // pattern: {
                  //   value: /^(?=.*[A-Z])(?=.*[!@#$%^&*])(?=.*[0-9]).{8,}$/,
                  //   message:
                  //     "Must contain at least one uppercase letter, one special character, and one digit",
                  // },
                })}
                inputMode="text"
                type="password"
                placeholder="Type..."
                className="modal-input "
              />
              {errors.confirm_password && (
                <span className="error">{errors.confirm_password.message}</span>
              )}
            </div>
          </div>
        </div>
        <div className="setting-bottom h-center mt-4">
          <button type="submit" className="setting-button">
            Confirm
          </button>
        </div>
      </form>
    </>
  );
};

export default ChangepswdComp;
